const urlUtils = require('utils/Url');
const ufeApi = require('services/api/ufeApi');

/* eslint-disable max-len */
// API documentation: https://stage-developer.sephora.com/specs/v1/docs/store.html#cancelling-an-appointment
/* eslint-enable max-len */

function cancelReservation(token, confirmationNumber){
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    let url = sdnDomain + '/v1/olr/reservations/'+ confirmationNumber;
    var options =
        {
            method: 'DELETE',
            url: url,
            headers: { authorization: `Bearer ${token}` },
            mode: 'cors',
            credentials: 'omit'
        };

    return ufeApi.makeRequest(url, options)
        .then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = cancelReservation;
